import Vconsole from 'vconsole'
let vConsole = new Vconsole({ theme: 'dark' })
export default vConsole